import { BaseQueovalItem, QueovalBase } from '../global';

export class SegmentationModel extends QueovalBase {
  public IdDonneePere: string;
  public IdDonneeFils: string;
  public IdentBO: string;
  public rank: string;
  public Items: SegmentationItem[];
}

export class SegmentationItem {
  public title: string;
  public defaultTitle: string;
  public cx?: number;
  public cy?: number;
  public img: string;
  public isSelected: boolean;
  public idRelation: string;
  public showSaveButton: boolean;
  public showRemoveButton: boolean;
  public showCreateButton: boolean;
  public showImportButton: boolean;
  public file: string;
  public origine: string;
  public idBO: string;
  public completeWhere: string;
  public isRelationReel: boolean;
  public isPreview: boolean;
  public OpenContext: boolean;
  public value: string;
  public itemNumber: string;
  public order: string;
  public sort: string;
  public sortDirection: string;
  public tableColumns: Array<BaseQueovalItem>;
}

export class ModelElement {
  public i: number;
  public item: SegmentationItem;
}
